<template>
  <div>
    <HeadingDisplay
      title=""
      avatar-type="image"
      avatar-content="371"
      avatar-alt=""
    >
      <template #title-component>
        <Heading :level="3">{{ bankName }}</Heading>
      </template>
      <template #subtitle-component>
        <BaseText size="p6">Conta Corrente</BaseText>
      </template>
    </HeadingDisplay>
    <div class="deposit-method__ted-account">
      <div v-for="(bankInfo, index) in computedBankInfo" :key="index">
        <BaseText size="p4">{{ bankInfo.label }}</BaseText>
        <BaseText
          :class="getAccountValueStyle(bankInfo.label)"
          size="p4"
          :color="NebraskaColors.elementPrimary"
        >
          {{ bankInfo.value }}
        </BaseText>
      </div>
      <div><CopyButton :value="props.depositInformation?.account" /></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  Heading,
  HeadingDisplay,
  BaseText,
  CopyButton
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ICustomerBankAccountResponse } from '@/modules/transaction/services/new-deposit';
import { computed } from 'vue';

interface Props {
  depositInformation: ICustomerBankAccountResponse['bankAccount'];
}

const props = defineProps<Props>();

const computedBankInfo = computed(() => {
  return [
    {
      label: 'Banco',
      value: props.depositInformation?.bankCode
    },
    {
      label: 'Agência',
      value: props.depositInformation?.agency
    },
    {
      label: 'Conta',
      value: props.depositInformation?.account
    }
  ];
});

const bankName = computed(() => {
  return props.depositInformation?.bankName;
});

function getAccountValueStyle(label: string) {
  return label === 'Conta' ? 'deposit-method__account-value' : '';
}
</script>

<style lang="less" scoped>
.deposit-method {
  &__ted-account {
    display: flex;
    margin-top: @size-spacing-x500;

    > div {
      flex: 1;

      &:last-of-type {
        align-self: center;
        text-align: right;
      }
    }
  }

  &__account-value {
    .to-sm({
      min-width: 90px;
    });
  }
}
</style>
